const treat = (value = null, type = null, t = null) => {
    // Se type é null ou undefined, retorna o valor sem tratamento
    if (type === null || type === undefined) {
        return value
    }

    switch (type) {
        case 'string':
            return treatString(value)
        case 'number':
            return treatNumber(value)
        case 'boolean-int':
            return treatBooleanInt(value)
        case 'boolean':
            return treatBoolean(value)
        case 'Bool':
            return treatBool(value)
        case 'model':
            return treatModel(value, t)
        case 'array':
            return treatArray(value, t)
        default:
            return value
    }
}

const treatString = (value = '') => {
    value = typeof value === 'string' ? value.trim() : ''
    return value.length === 0 ? null : value
}

const treatNumber = (value = 0) => {
    if (typeof value === 'string' && /^-?\d*\.?\d+$/.test(value))
        value = parseFloat(value)
    return typeof value === 'number' ? value : null
}

const treatBooleanInt = (value = 0) => {
    if (typeof value === 'string' && /^\d+$/.test(value))
        value = parseInt(value)
    return value === 1 ? 1 : 0
}

const treatBoolean = (value = false) => {
    return typeof value === 'boolean' ? value : false
}

const treatBool = (value = null) => {
    return typeof value === 'boolean' ? value : null
}

const treatModel = (value = null, model = null) => {
    if (typeof model !== 'function') return null
    return new model(value instanceof model ? value.serialize() : value)
}

const treatArray = (value = null, cast = null) => {
    if (!Array.isArray(value) || cast === undefined) return []

    let arr = []
    for (const i in value) {
        arr.push(treatArrayItem(value[i], cast))
    }

    return arr
}

const treatArrayItem = (value = null, cast = null) => {
    const getType = () => {
        if (typeof cast === 'function') return 'model'
        return typeof cast === 'string' ? cast : undefined
    }

    const getT = () => {
        if (getType() === 'model') return cast
        return undefined
    }

    return treat(value, getType(), getT())
}

export default treat
export {
    treat,
    treatString,
    treatNumber,
    treatBoolean,
    treatModel,
    treatArray,
    treatArrayItem,
}
